<template>
  <div class="wrapper">
    <div class="log_bg">
      <div>
        <img src="../../assets/images/logo.jpg" alt="">
      </div>
      <div class="success">
        恭喜您，注册成功
      </div>
      <div class="qcode">
        <div>
          <img src="../../assets/images/qrcode.jpg" alt="">
        </div>
        <div>
          欲了解更多精彩直播内容，请关注2020CMDHRA直播平台。
        </div>
      </div>

      <div class="todetails">
        <a :href="url">点击观看直播</a>

      </div>
    </div>



  </div>
</template>
<script>
  export default {
    data() {
      return {
        url:"",
      }
    },
    props: {},
    methods: {},
    computed: {},
    mounted() {
      //http://medical.medcircle.cn/illumina/details?type=live&liveId=147
      let url= window.location.href
      if(url.includes('medical.medcircle.cn')){
        this.url = 'http://medical.medcircle.cn/illumina/details?type=live&liveId=147';//生产环境

      }else if(url.includes('www.medcircle.top')){
        this.url = 'http://www.medcircle.top/illumina/details?type=live&liveId=147';//测试环境
      }else{
        this.url = 'http://192.168.2.252:8081/illumina/details?type=live&liveId=147';//测试环境
      }
    }
  }
</script>
<style scoped lang="scss">
  .log_bg{
    width: 7.5rem;
    min-height: 100vh;
    background: url("../../assets/images/meBg.png") no-repeat;
    -webkit-background-size: 100%;
    background-size: 100%;
    >div{
      width: 7.5rem;
      text-align: center;
      >img{
        width: 3.8rem;
        margin-top: 1.33rem ;
      }
    }
    .success{
      text-align: center;
      color: #FFB441;
      font-size: 0.32rem;
      margin-top: 1.03rem;
      margin-bottom: 0.7rem;
    }
    .qcode{
      font-size: 0.26rem;
      text-align: center;
      >div{
        width:3.2rem;
        margin: 0 auto 0.24rem;
      }
      >div:nth-of-type(1){
        background: url("../../assets/images/border1.png") no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        height: 3.1rem;
        img{
          width: 2.16rem;
          margin-top: 0.43rem;
        }
      }

      >div:nth-of-type(2){

      }
    }
    .todetails{
      width: 6rem;
      height: 0.9rem;
      background:#FFB441;
      color: #FFFFFF;
      font-size: 0.36rem;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      line-height: 0.9rem;
      margin: 1.28rem auto 2rem;
      a{
        color: #FFFFFF !important;
        width: 100%;
        height: 100%;
        display: inline-block;
        border-radius: 5px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/container/activeInfo_tpl.vue